import { spaceGQLFields } from '@tribeplatform/gql-client/graphql';
const BASIC_TEMPLATE_REQUEST_FIELDS = {};
const ALL_TEMPLATE_REQUEST_FIELDS = {
    createdEntity: 'basic',
};
export function templateRequestGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_TEMPLATE_REQUEST_FIELDS;
    if (fields === 'all')
        fields = ALL_TEMPLATE_REQUEST_FIELDS;
    return `
    id
    status
    networkId
    templateId
    createdAt
    createdById
    createdEntityId
    createdEntityType
    processedPercentage
    updatedAt
    ${fields.createdEntity
        ? `
      createdEntity {
      ...on Space {
        ${spaceGQLFields(fields.createdEntity)}
        }
      }
    `
        : ``}
  `;
}
